import React from 'react';
import { Text, createStyles } from '@mantine/core';
import { useSelector } from 'react-redux';
import tinycolor from 'tinycolor2';
import { DateTime } from "luxon";

import useSidebarStyles from "../../../../../utils/SidebarStyles";
import isSpaceThemed from '../../../../../utils/IsSpaceThemed';
import { numberFormat, dateFormat, isUrl, getLocationFormat } from '../../../../../utils/Filters';

const useStyles = createStyles((theme, {colors, settingsView, context}) => ({
  freeformResponse: {
    display: 'flex',
    alignItems: 'flex-start',
    borderRadius: theme.radius.md,
    backgroundColor: isSpaceThemed(colors) && !settingsView && context != "settings" ? tinycolor(colors.sidebar_background_color).lighten(7).toString() : theme.colors.gray[1],
    paddingTop: 10,
    paddingBottom: 10,
    paddingRight: 10,
    paddingLeft: 10,
    marginTop: 10,
    width: "100%",
    fontSize: 14
  }
}));

export default function TextBased({ context, response, format, options }) {
  const { settingsView } = useSidebarStyles();
  const colors = useSelector(state => state.colors);
  const { classes } = useStyles({colors, settingsView, context});

  const displayText = () => {
    if (response) {
      if (format === "number") {
        const symbol = numberFormat.find((n) => n.value === options?.format)?.symbol || "";
        const s_1 = options?.format !== "percent" ? symbol : "";
        const s_2 = options?.format === "percent"? symbol : "";
        const text = Number(response).toFixed(Number(options?.decimal_places || 0));
        return `${s_1}${text}${s_2}`;
      } else if (format === "date") {
        const displayDateFormat = dateFormat.find((d) => d.value === options?.format)?.format || "DDD";
        return DateTime.fromISO(response).toFormat(displayDateFormat);
      } else if (format === "location") {
        const locationFormat = options?.format || "city_country";
        const locationValue = getLocationFormat(response, locationFormat);
        return locationValue || "Location";
      }
      return response;
    }
    return "";
  };

  const cleanUrl = (url) => {
    return url
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '');
  };

  if (format === "url") {
    const parts = response.split(/[\s,]+/).filter(Boolean);
    return parts.map((part, partIndex) => {
      const isUrlValue = isUrl(part);
      return (
        <Text
          key={partIndex}
          size="sm"
          lineClamp={2}
          style={{
            textDecorationLine: isUrlValue ? "underline" : undefined,
            lineHeight: 1.3
          }}
          className={classes.freeformResponse}
        >
          {cleanUrl(part)}
        </Text>
      );
    });
  }

  return (
    <Text className={classes.freeformResponse}>
      {displayText()}
    </Text>
  );
}
